// extracted by mini-css-extract-plugin
export default {"toasts-container":"toastprovider_toasts-container__3HTI6"};